/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const NeutralFaceIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path
      d="M9.03177 8.8287V12.7157M16.8057 8.8287V12.7157M16.8057 17.8253C16.8057 17.8253 16.0283 17.8253 12.9188 17.8253C9.80917 17.8253 9.03177 17.8253 9.03177 17.8253M24.5797 12.9383C24.5797 19.3777 19.3582 24.5992 12.9188 24.5992C6.47932 24.5992 1.25781 19.3777 1.25781 12.9383C1.25781 6.49885 6.47932 1.27734 12.9188 1.27734C19.3582 1.27734 24.5797 6.49885 24.5797 12.9383Z"
      stroke="#1D1D1B"
      strokeWidth="1.69636"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
